import React from 'react';

import { RadioInput, RadioInputProps } from '@components/NextForms/RadioInput';
import { MobxZodTypes } from '@monoid-dev/mobx-zod-form';
import { getForm } from '@monoid-dev/mobx-zod-form-react';
import { useCommonStyles } from '@styles/index';
import { observer } from 'mobx-react';

export type RadioInputControlProps<T extends MobxZodTypes> = RadioInputProps<T> & {
  /**
   * @default {'block'}
   * 'block' for wrapping radio and label in a <div>
   */
  variant?: 'block';
  /**
   * @default {value}
   */
  labelChild?: React.ReactNode;
};

export const RadioInputControl = observer(
  <T extends MobxZodTypes>({
    variant = 'block',
    labelChild: _labelChild,
    ...radioInputProps
  }: RadioInputControlProps<T>) => {
    const { field, value, disabled } = radioInputProps;

    const form = getForm(field);

    const labelChild = _labelChild ?? value;

    const classes = useCommonStyles();

    if (variant === 'block') {
      return (
        <div>
          <div style={{ display: 'inline-block', position: 'relative', top: -1 }}>
            <RadioInput {...radioInputProps} />
          </div>
          <label
            {...form.bindLabel(field, {
              type: 'radio',
              value,
            })}
            style={{ cursor: 'pointer' }}
            className={disabled ? classes.textGray500 : undefined}
          >
            {labelChild}
          </label>
        </div>
      );
    }
    return null;
  },
);
